import assign from 'lodash.assign';

const { createHigherOrderComponent } = wp.compose;
const { Fragment, useState } = wp.element;
const { InspectorControls } = wp.editor;
const { PanelBody, SelectControl, TextControl } = wp.components;
const { addFilter } = wp.hooks;
const { __ } = wp.i18n;

import DASHICON from '../icons/dashicon';
import MDICON from '../icons/material';


const fontControlOptions = [
    {
        label: __('Dashicons'),
        value: 'dashicons',
    },
    {
        label: __('Material Icon'),
        value: 'material',
    }
];


wp.blocks.registerBlockVariation('core/paragraph', {
    name: "sp-icon",
    title: 'Icons',
    keywords: [ "icon" ],
    icon: 'buddicons-groups',
    isDefault: false,
    category: "text",
    scope: [ "inserter", "transform", "block" ],
    description: "Insert a customizable SVG icon.",
    attributes: { className: "has-sp-icon", iconSet: 'dashicons' },
    isActive: (e) => {
        if (e.className && e.className.includes('has-sp-icon')) {
            return true;
        }
        return false;
    },

});


// Enable spacing control on the following blocks
const enableCounterControlOnBlocks = [
    'core/paragraph',
];

/**
 * Add spacing control attribute to block.
 *
 * @param {object} settings Current block settings.
 * @param {string} name Name of block.
 *
 * @returns {object} Modified block settings.
 */
const addIconControlAttribute = (settings, name) => {
    // Do nothing if it's another block than our defined ones.
    if (!enableCounterControlOnBlocks.includes(name)) {
        return settings;
    }

    // Use Lodash's assign to gracefully handle if attributes are undefined
    settings.attributes = assign(settings.attributes, {
        iconSet: { type: "string", default: "dashicons" },
        iconName: { type: "string", default: "dashicons-wordpress" }

    });

    return settings;
};

addFilter('blocks.registerBlockType', 'extend-block-example/icons/data', addIconControlAttribute);



/**
 * Create HOC to add spacing control to inspector controls of block.
 */
const withIconControl = createHigherOrderComponent((BlockEdit) => {
    return (props) => {
        const { setAttributes } = props;
        const { iconName } = props.attributes;


        // console.log(props);
        // Do nothing if it's another block than our defined ones.
        if (!enableCounterControlOnBlocks.includes(props.name)) {
            return (
                <BlockEdit { ...props } />
            );
        }

        if (!(props.attributes.className && props.attributes.className.includes('has-sp-icon'))) {
            return (
                <BlockEdit { ...props } />
            )
        }


        const [ search, materialIconSearch ] = useState("");
        console.log(search);
        // search handler
        const materialIconList = MDICON.filter((item) => {

            if (search == "") {
                return item
            }
            else if (item.toLowerCase().includes(search.toLowerCase())) {
                return item
            }
        });

        const [ dsearch, dashIconsSearch ] = useState("");
        // search handler
        const dashIconList = DASHICON.filter((item) => {

            if (dsearch == "") {
                return item
            }
            else if (item.toLowerCase().includes(dsearch.toLowerCase())) {
                return item
            }
        });


        const selectIcon = (icon) => {

            // if (props.attributes.iconSet == 'material') {
            //     setAttributes({ content: icon.currentTarget.dataset[ 'icon' ] });
            // }

            setAttributes({ iconName: icon.currentTarget.dataset[ 'icon' ] });
        }

        return (
            <Fragment>
                <BlockEdit { ...props } />

                <InspectorControls>
                    <PanelBody
                        title={ __('Icon Settings') }
                        initialOpen={ true }
                    >


                        <SelectControl
                            label={ __('Icon Set') }
                            value={ props.attributes.iconSet }
                            options={ fontControlOptions }
                            onChange={ (selectedIconSet) => {
                                props.setAttributes({
                                    iconSet: selectedIconSet,
                                });
                            } }
                        />

                        { props.attributes.iconSet === 'dashicons' &&
                            <Fragment>
                                <TextControl
                                    type="text"
                                    className="searchbox"
                                    onChange={ (val) => dashIconsSearch(val) }
                                />

                                <ul className='wp-dashicons-list editor-styles-wrapper'
                                    style={

                                        {
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: "2px",
                                            maxHeight: "250px",
                                            overflowX: "scroll"
                                        }

                                    }
                                >
                                    { dashIconList.map(function (d) {
                                        return (
                                            <li
                                                className={ iconName === d ? 'active' : '' }

                                                data-icon={ d }
                                                style={
                                                    iconName == d ? {
                                                        padding: "2px",
                                                        cursor: "pointer",
                                                        background: '#000',
                                                        color: "#fff",
                                                        borderRadius: "5px"
                                                    } :
                                                        {
                                                            padding: "2px",
                                                            cursor: "pointer"
                                                        } }

                                                onClick={ selectIcon } > <span key={ d } className={ 'dashicons ' + d }></span></li>
                                        )
                                    }) }

                                </ul>
                            </Fragment>
                        }

                        { props.attributes.iconSet === 'material' &&
                            <Fragment>
                                <TextControl
                                    type="text"
                                    className="searchbox"
                                    onChange={ (val) => materialIconSearch(val) }
                                />


                                <ul className='wp-material-list'
                                    style={

                                        {
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: "2px",
                                            maxHeight: "250px",
                                            overflowX: "scroll"
                                        }

                                    }
                                >

                                    { materialIconList.map(function (d) {
                                        return (
                                            <li
                                                className={ iconName === d ? 'active' : '' }

                                                data-icon={ d }
                                                style={
                                                    iconName == d ? {
                                                        padding: "2px",
                                                        cursor: "pointer",
                                                        background: '#000',
                                                        color: "#fff",
                                                        borderRadius: "5px"
                                                    } :
                                                        {
                                                            padding: "2px",
                                                            cursor: "pointer"
                                                        } }

                                                onClick={ selectIcon } >
                                                <span class="material-icons">
                                                    { d }
                                                </span>
                                                <span key={ d } className={ d }></span></li>
                                        )
                                    }) }

                                </ul>
                            </Fragment>
                        }



                    </PanelBody>
                </InspectorControls>
            </Fragment >
        );
    };
}, 'withIconControl');

addFilter('editor.BlockEdit', 'extend-block-example/with-icons-control', withIconControl);





const withIconClassName = createHigherOrderComponent(
    (BlockListBlock) => {
        return (props) => {
            // console.log(props);
            // Do nothing if it's another block than our defined ones.
            if (!enableCounterControlOnBlocks.includes(props.name)) {
                return (
                    <BlockListBlock { ...props } />
                );
            }

            if (!(props.attributes.className && props.attributes.className.includes('has-sp-icon'))) {
                return (
                    <BlockListBlock { ...props } />
                )
            }

            var selectedIcon = 'dashicons ' + props.attributes.iconName;
            if (props.attributes.iconSet === 'material') {
                selectedIcon = 'material-icons ' + props.attributes.iconName;
            }

            return (
                <BlockListBlock
                    { ...props }
                    className={ 'has-sp-icon ' + selectedIcon }
                    wrapperProps={ { 'data-icon': props.attributes.iconName } }
                />
            );
        };
    },
    'withIconClassName'
);

wp.hooks.addFilter(
    'editor.BlockListBlock',
    'my-plugin/with-icon-class',
    withIconClassName
);